export default __webpack_public_path__ + "static/media/theatre.26f794d6.svg";